import AuthenticatedView from "./AuthenticatedView"
export default AuthenticatedView
